import { action, makeObservable, observable, reaction } from 'mobx';
import { UiStore } from './ui';
import { appConfig } from '../settings';
import { IFilterParams, IRateImportItemError, IRateImportItemRAW, IRateListItem, ISelectList } from '../interfaces';
import { getImportList, getRatesList, getRatesListV2 } from '../middleware';
import { apiParamsCleaner } from '../instruments';

export class RatesStore {
    private constructor() {
        makeObservable(this);
        reaction(
            () => this.forcedUpdateTime.toString() + this.isV2.toString(),
            () => {
                const UiStoreInstance = UiStore.getInstance();
                const params = UiStoreInstance.params;
                const cleanParams = apiParamsCleaner(params, this.filterParams);
                if (this.isV2) {
                    getRatesListV2(cleanParams).then();
                } else {
                    getRatesList(cleanParams).then();
                }
            },
            {
                delay: appConfig.APIDelay,
            },
        );
        reaction(
            () => this.forcedUpdateImportTime,
            () => {
                const UiStoreInstance = UiStore.getInstance();
                const params = UiStoreInstance.params;
                const cleanParams = apiParamsCleaner(params, this.filterImportParams);
                getImportList(cleanParams).then();
            },
            {
                delay: appConfig.APIDelay,
            },
        );
    }

    private static instance: RatesStore;
    public static getInstance(): RatesStore {
        if (!RatesStore.instance) {
            RatesStore.instance = new RatesStore();
        }
        return RatesStore.instance;
    }

    @observable isV2 = false;
    @action setIsV2(isV2?: boolean): void {
        this.isV2 = Boolean(isV2);
    }

    @observable select: ISelectList = [];
    @action setRateSelect(select: ISelectList): void {
        this.select = select;
    }

    @observable list: IRateListItem[] = [];
    @action setList(list: IRateListItem[]): void {
        this.list = list;
    }

    @observable importList: IRateImportItemRAW[] = [];
    @action setImportList(list: IRateImportItemRAW[]): void {
        this.importList = list;
    }
    @observable importErrorList: IRateImportItemError[] = [];
    @action setImportErrorList(list: IRateImportItemError[]): void {
        this.importErrorList = list;
    }

    @action cleanStore(): void {
        this.list = [];
        this.importList = [];
        this.importErrorList = [];
        this.select = [];
        this.isV2 = false;
    }

    @observable forcedUpdateTime = 0;
    @action setForcedUpdateTime(): void {
        this.forcedUpdateTime = Date.now();
    }

    @observable forcedUpdateImportTime = 0;
    @action setForcedUpdateImportTime(): void {
        this.forcedUpdateImportTime = Date.now();
    }

    @observable filterParams: IFilterParams = {
        pageNumber: true,
        pageSize: true,
        search: true,
    };
    @observable filterImportParams: IFilterParams = {
        pageNumber: true,
        importType: true,
        pageSize: true,
        search: true,
        // ToDo: 07.04.2026 - API has filters filter[user_id] and filter[status]= ENQUEUED, IN_PROGRESS, DONE, FAILED, but they are not added, need add params
    };
}
